import { SimpleGrid } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import { aboutPagesArray } from 'staticPages/aboutPagesArray';
import AboutCard from './aboutCard';
import DashboardReportApi from 'api/dashboardreport';
import PageError from 'components/nopermission/PageError';
import { useAuth } from 'auth-context/auth.context';

const CardStack = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterStartDate, setFilterStartDate] = useState();
  const [filterEndDate, setFilterEndDate] = useState();
  const [dashboardReportApiError, setDashboardReportApiError] = useState(false);
  const { user } = useAuth();

  const FetchDashboardReport = async () => {
    if (user?.user_type === 'SHOWROOM') {
      return;
    }
    try {
      setLoading(true);
      let response = await DashboardReportApi.List({
        filterStartDate,
        filterEndDate,
      });
      response = response.data;
      console.log('Response from DashboardReportApi', response);
      setLoading(false);
      if (response.status_code === 200) {
        setDashboardReportApiError(false);
        setList(response?.data);
        console.log(list);
      } else {
        setDashboardReportApiError(true);
        setList([]);
      }
    } catch (err) {
      console.log(err);
      setDashboardReportApiError(true);
      setList([]);
    }
  };

  useEffect(() => {
    FetchDashboardReport();
  }, [filterStartDate, filterEndDate]);

  return dashboardReportApiError ? (
    <PageError />
  ) : (
    <SimpleGrid
      columns={{ xl: 3, '2xl': 4, '3xl': 5 }}
      gap='20px'>
      {list?.map((card) => (
        <AboutCard
          key={card.key}
          keyValue={card.key}
          title={card.Title}
          Value={card.Value}
        />
      ))}
    </SimpleGrid>
  );
};

export default CardStack;
